import axios from './index'

class money {
    //渠道资金列表
    static distributorMoney(params) {
        return axios.get('/app-admin/distributor/query/page_list',{params:params})
    }

    //渠道充值
    static distributorAddMoney(params) {
        return axios.put('/app-admin/recharge-apply/distributor/add',params)
    }

    
    //充值详情
    static distributrMoneyDetail(params) {
        return axios.get('/app-admin/recharge-apply/detail',{params:params})
    }

    //供应资金列表
    static supplierMoney(params) {
        return axios.get('/app-admin/supplier/query/page_list',{params:params})
    }


    //供应充值
    static supplierAddMoney(params) {
        return axios.put('/app-admin/recharge-apply/supplier/add',params)
    }

    //渠道资金
    static getBalanceById(params) {
        return axios.get('/app-admin/distributor/query/getBalanceById',{params:params})
    }


    
}

export default money;
